﻿import React, { useEffect, useState } from 'react';
import * as ValgTypes from '../Store/Valg/Types';
import { SatserUtlandModel } from '../Models/SatserUtlandModel';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import * as UtregningUtland from '../Utilities/Utregning';
import VarighetValg from '../Utilities/VarighetValg';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';

interface UtregningAProps {
    tittelUtregning: JSX.Element | null;
    satser: SatserUtlandModel | null;
    valg: ValgTypes.ValgState;
    valutaBenevnelseUtregning: string;
    stipendVilkarTekst: JSX.Element | null;
    stipendTittelUtregning: JSX.Element | null;
    lanTittelUtregning: JSX.Element | null;
    tekstForLanOgStipendSomAlleFaar: JSX.Element | null;
    tekstForDeMedSkolepenger: JSX.Element | null;
    tekstForDeMedSkolepengerOgTilleggsstipend: JSX.Element | null;
    tekstForDeMedSkolepengerOgTilleggsstipendOgTilleggslan: JSX.Element | null;
    tekstForDeMedSkolepengerOgTilleggslan: JSX.Element | null;
    tekstForBiStudenterMedSkolepenger: JSX.Element | null;
    tekstForBiStudenterMed0Skolepenger: JSX.Element | null;
    vilkarStudieStotteLenkeTekst: JSX.Element | null;
    vilkarStudieStotteTittel: JSX.Element | null;
    vilkarStudieStotteTekst: JSX.Element | null;
    vilkarLukkStudieStottePopupAriaTekst: string;
    visUtbetalingsPlanHandler: any;
    utbetalingsPlanLenkeTekst: JSX.Element | null;
    locale: string;
    TekstForLanOgStipendSomAlleFaarOgTilleggsstipendUtveksling: JSX.Element | null;
    tekstForDeMedSkolepengerTilleggsstipendOgTilleggsstipendUtveksling: JSX.Element | null;
    tekstForDeMedSkolepengerOgTilleggsstipendTilleggslanOgTilleggsstipendUtveksling: JSX.Element | null;
    tekstForDeMedSkolepengerTilleggslanOgTilleggsstipendUtveksling: JSX.Element | null;
    tekstForDeMedSkolepengerOgTilleggsstipendUtveksling: JSX.Element | null;
    eventId: string | null;
}

export default function UtregningFa(props: UtregningAProps): JSX.Element {
    const [visVilkarAModal, setVisVilkarAModal] = useState(false);
    const [visUtbetalingsplan, setVisUtbetalingsplan] = useState(false);

    useEffect(() => {
        updateLiveMessage();
    }, []);
    
    function onVilkarAClick(): void {
        setVisVilkarAModal(true);
    }

    function onRequestLukkVilkarA(): void {
        setVisVilkarAModal(false);
    }

    function onVisUtbetalingsPlan(): void {
        if (visUtbetalingsplan) {
            setVisUtbetalingsplan(false);
            props.visUtbetalingsPlanHandler(false);
        } else {
            setVisUtbetalingsplan(true);
            props.visUtbetalingsPlanHandler(true);
        }
    }

    function erTildeltRekrutteringsstipendUtveksling() {
        if (UtregningUtland.regnUtRekrutteringsstipendUtveksling(props.valg, props.satser) > 0) return true;
        return false;
    }

    function hentYtelsesBeskrivelseTekst(): JSX.Element | null {
        if (props.valg.dSkolepenger == undefined) return null;
        if (props.satser == undefined) return null;

         
        let skoleKostnad: number = parseInt(props.valg.dSkolepenger.value.replace(/\s/g, ''));

        let nevnerBrok: number = 1;

        if (
            props.valg.aVarighet?.value === VarighetValg.valgHost ||
            props.valg.aVarighet?.value === VarighetValg.valgVaar
        ) {
            nevnerBrok = 2;
        }

        console.log("erTildeltRekrutteringsstipendUtveksling = "+erTildeltRekrutteringsstipendUtveksling());
        console.log("UtregningUtland.harValgtGodkjentUniversitetSomGirUtvidetStipend(props.valg) = "+UtregningUtland.harValgtGodkjentUniversitetSomGirUtvidetStipend(props.valg));
        console.log("props.valg.dSkolepenger.tillegg = "+props.valg.dSkolepenger.tillegg);    
        console.log("skoleKostnad < SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAr = "+ (skoleKostnad < props.satser?.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR / nevnerBrok) );
        
        //hvis D4 (BI) er sjekket og D1=0
        if (props.valg.dSkolepenger.tillegg && skoleKostnad === 0) {
            return <span>{props.tekstForBiStudenterMed0Skolepenger}</span>;
        }

        //hvis D4 (BI) er sjekket og D1 > 0
        if (props.valg.dSkolepenger.tillegg && skoleKostnad > 0 && !erTildeltRekrutteringsstipendUtveksling()) {
            return <span>{props.tekstForBiStudenterMedSkolepenger}</span>;
        }

        //hvis D1 < ID6 og D1 > 0
        if (
            skoleKostnad < props.satser?.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR / nevnerBrok &&
            skoleKostnad > 0 && 
            !UtregningUtland.harValgtGodkjentUniversitetSomGirUtvidetStipend(props.valg) &&
            !erTildeltRekrutteringsstipendUtveksling()
        ) {
            return <span>{props.tekstForDeMedSkolepenger}</span>;
        }
        //ny
        if (
            skoleKostnad < props.satser?.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR / nevnerBrok &&
            skoleKostnad > 0 && 
            !UtregningUtland.harValgtGodkjentUniversitetSomGirUtvidetStipend(props.valg) && 
            erTildeltRekrutteringsstipendUtveksling()
        ) {
            return <span>{props.tekstForDeMedSkolepengerOgTilleggsstipendUtveksling}</span>;
        }

        //hvis D1 < ID6+ID10 og E1=ja
        if (
            skoleKostnad <
                props.satser?.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR +
                    props.satser?.SATS_ST01_TILLEGGSTIPEND_MAKS_PER_AAR / nevnerBrok &&
            UtregningUtland.harValgtGodkjentUniversitetSomGirUtvidetStipend(props.valg) &&
            !erTildeltRekrutteringsstipendUtveksling()
        ) {
            return <span>{props.tekstForDeMedSkolepengerOgTilleggsstipend}</span>;
        }
        if (
            skoleKostnad <
                props.satser?.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR +
                    props.satser?.SATS_ST01_TILLEGGSTIPEND_MAKS_PER_AAR / nevnerBrok &&
            UtregningUtland.harValgtGodkjentUniversitetSomGirUtvidetStipend(props.valg) &&
            erTildeltRekrutteringsstipendUtveksling()
        ) {
            return <span>{props.tekstForDeMedSkolepengerTilleggsstipendOgTilleggsstipendUtveksling}</span>;
        }

        //hvis D1 > ID6+ID10 og E1=ja
        if (
            skoleKostnad >
                props.satser?.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR +
                    props.satser?.SATS_ST01_TILLEGGSTIPEND_MAKS_PER_AAR / nevnerBrok &&
            UtregningUtland.harValgtGodkjentUniversitetSomGirUtvidetStipend(props.valg) &&
            !erTildeltRekrutteringsstipendUtveksling()
        ) {
            return <span>{props.tekstForDeMedSkolepengerOgTilleggsstipendOgTilleggslan}</span>;
        }
        if (
            skoleKostnad >
                props.satser?.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR +
                    props.satser?.SATS_ST01_TILLEGGSTIPEND_MAKS_PER_AAR / nevnerBrok &&
            UtregningUtland.harValgtGodkjentUniversitetSomGirUtvidetStipend(props.valg) &&
            erTildeltRekrutteringsstipendUtveksling()
        ) {
            return <span>{props.tekstForDeMedSkolepengerOgTilleggsstipendTilleggslanOgTilleggsstipendUtveksling}</span>;
        }

        //hvis D1 > ID6 og E1=nei
        if (
            skoleKostnad > props.satser?.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR / nevnerBrok &&
            !UtregningUtland.harValgtGodkjentUniversitetSomGirUtvidetStipend(props.valg) &&
            !erTildeltRekrutteringsstipendUtveksling()
        ) {
            return <span>{props.tekstForDeMedSkolepengerOgTilleggslan}</span>;
        }
        
        //
        if (
            skoleKostnad > props.satser?.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR / nevnerBrok &&
            !UtregningUtland.harValgtGodkjentUniversitetSomGirUtvidetStipend(props.valg) &&
            erTildeltRekrutteringsstipendUtveksling()
        ) {
            return <span>{props.tekstForDeMedSkolepengerTilleggslanOgTilleggsstipendUtveksling}</span>;
        }              

        if (erTildeltRekrutteringsstipendUtveksling()) {
            return <span>{props.TekstForLanOgStipendSomAlleFaarOgTilleggsstipendUtveksling}</span>;
        } else {
            return <span>{props.tekstForLanOgStipendSomAlleFaar}</span>;
        }
    }

    return (
        <div className="c-veileder__panel c-veileder__panel--resultat c-veileder__panel--aubergine" id="UtregningFa">
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content c-veileder__content--header">
                    <h3 className="c-veileder__tittel c-veileder__tittel--resultat">{props.tittelUtregning}</h3>
                </div>
                <div className="c-veileder__content c-veileder__content--header c-veileder__content--indented">
                    <div className="c-veileder__resultat-tekst">
                        <span>
                            {UtregningUtland.formatNumber(
                                UtregningUtland.regnUtBasisLan(props.valg, props.satser).totaltStipendOgLan +
                                    UtregningUtland.regnUtReiseStotte(props.valg, props.satser).totaltStipendOgLan +
                                    UtregningUtland.regnUtSkolepengerStotte(props.valg, props.satser)
                                        .totaltStipendOgLan +
                                    UtregningUtland.regnUtRekrutteringsstipendUtveksling(props.valg, props.satser),
                                props.locale,
                            )}
                        </span>
                        <span className="c-veileder__tekst c-veileder__tekst--postfix">
                            &nbsp;{props.valutaBenevnelseUtregning}
                        </span>
                    </div>
                    <p className="c-veileder__tekst c-veileder__tekst--tett">{hentYtelsesBeskrivelseTekst()}</p>
                </div>
            </div>
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content"></div>
                <div className="c-veileder__content c-veileder__content--header c-veileder__content--indented">
                    <div className="c-veileder__resultat-tekst-overskrift">{props.stipendTittelUtregning}</div>

                    <div className="c-veileder__underresultat-tekst">
                        <span>
                            {UtregningUtland.formatNumber(
                                UtregningUtland.regnUtBasisLan(props.valg, props.satser).stipendKroner +
                                    UtregningUtland.regnUtReiseStotte(props.valg, props.satser).stipendKroner +
                                    UtregningUtland.regnUtSkolepengerStotte(props.valg, props.satser).stipendKroner +
                                    UtregningUtland.regnUtRekrutteringsstipendUtveksling(props.valg, props.satser),
                                props.locale,
                            )}
                        </span>
                        <span className="c-veileder__tekst c-veileder__tekst--postfix">
                            &nbsp;{props.valutaBenevnelseUtregning}
                        </span>
                    </div>
                    <p className="c-veileder__tekst c-veileder__tekst--tett">
                        <span>{props.stipendVilkarTekst}</span>
                    </p>
                </div>
            </div>
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content c-veileder__content--header"></div>
                <div className="c-veileder__content c-veileder__content--header c-veileder__content--indented">
                    <div className="c-veileder__resultat-tekst-overskrift">{props.lanTittelUtregning}</div>
                    <div className="c-veileder__underresultat-tekst">
                        <span>
                            {UtregningUtland.formatNumber(
                                UtregningUtland.regnUtBasisLan(props.valg, props.satser).lanKroner +
                                    UtregningUtland.regnUtReiseStotte(props.valg, props.satser).lanKroner +
                                    UtregningUtland.regnUtSkolepengerStotte(props.valg, props.satser).lanKroner,
                                props.locale,
                            )}
                        </span>
                        <span className="c-veileder__tekst c-veileder__tekst--postfix">
                            &nbsp;{props.valutaBenevnelseUtregning}
                        </span>
                    </div>
                </div>
            </div>
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content">
                    <button
                        type="button"
                        className="c-knapp c-knapp--lenke c-knapp--lenke-aubergine"
                        onClick={onVilkarAClick}
                    >
                        {props.vilkarStudieStotteLenkeTekst}
                    </button>
                    <ModalCompontent
                        isOpen={visVilkarAModal}
                        onRequestClose={onRequestLukkVilkarA}
                        ariaCloseText={props.vilkarLukkStudieStottePopupAriaTekst}
                        eventId={props.eventId}
                    >
                        <ArticleContentComponent
                            headerinnhold={props.vilkarStudieStotteTittel}
                            contentinnhold={props.vilkarStudieStotteTekst}
                        />
                    </ModalCompontent>
                </div>
                <div className="c-veileder__content c-veileder__content--indented">
                    <button
                        type="button"
                        className="c-knapp c-knapp--lenke c-knapp--fullwidth-ms c-knapp--centered c-knapp--icon-after c-knapp--pil-opp-hvit"
                        onClick={onVisUtbetalingsPlan}
                    >
                        {props.utbetalingsPlanLenkeTekst}
                    </button>
                </div>
            </div>
        </div>
    );
}
